import { convertirTextAMomentUTC } from "./dates";

const ordenar = (itemA, itemB) => {
  if (itemA > itemB) {
    return 1;
  }
  if (itemA < itemB) {
    return -1;
  }
  return 0;
};

const ordenarNums = (itemA, itemB) => itemA - itemB;

/**
 * Generar una funció per a ordenar alfabèticament objectes segons el valor d'un atribut.
 * @param {*} nomAtribut Atribut de l'objecte pel qual ordenar
 * @param {*} ignorarAccentsIMajuscules Default {true}. Ignorar accents i majúscules quan es fa l'ordenació.
 */
export const ordenarAlfabeticamentPerAtribut = (
  nomAtribut,
  ignorarAccentsIMajuscules = true
) => {
  return (elementAnterior, elementSeguent) => {
    const atributElementAnterior = elementAnterior[nomAtribut];
    const atributElementSeguent = elementSeguent[nomAtribut];
    const atributElementAnteriorNormalitzat = ignorarAccentsIMajuscules
      ? normalitzarTextSenseAccentsNiMajuscules(atributElementAnterior)
      : atributElementAnterior;
    const atributElementSeguentNormalitzat = ignorarAccentsIMajuscules
      ? normalitzarTextSenseAccentsNiMajuscules(atributElementSeguent)
      : atributElementSeguent;
    return ordenar(
      atributElementAnteriorNormalitzat,
      atributElementSeguentNormalitzat
    );
  };
};

export const ordenarAlfabeticamentPerAtributNom = ordenarAlfabeticamentPerAtribut(
  "nom"
);

/**
 * Ordena alfabèticament dos objectes.
 * @param {*} itemA
 * @param {*} itemB
 */
export const ordenarAlfabeticament = (itemA, itemB) => {
  return ordenar(itemA, itemB);
};

/**
 * Ordena alfabèticament dos objectes.
 * @param {*} itemA
 * @param {*} itemB
 */
export const ordenarNumericament = (itemA, itemB) => {
  return ordenarNums(itemA, itemB);
};

/**
 * Rep per parametre dos dates de tipus String amb la màscara genèrica de l'aplicació(YYYY-MM-DD[T]HH:MM+ZZ).
 * Converteix aquest dos parametres a moment i els compara.
 * @param {String} elementA
 * @param {String} elementB
 * @param {String} mascara
 * @return 1 si la data A es mayor que la data B, -1 si la data B mayor que A. 0 Si son iguals
 */
export const ordenacioDates = (dataAAstext, dataBAsText, mascara) => {
  const existeixDataA =
    dataAAstext === null || typeof dataAAstext === "undefined";
  const existeixDataB =
    dataBAsText === null || typeof dataBAsText === "undefined";

  if (existeixDataA && existeixDataB) {
    return 0;
  }
  if (existeixDataA) {
    return 1;
  }
  if (existeixDataB) {
    return -1;
  }

  const dataA = convertirTextAMomentUTC(dataAAstext, mascara);
  const dataB = convertirTextAMomentUTC(dataBAsText, mascara);

  if (dataA.isAfter(dataB)) {
    return 1;
  }
  if (dataA.isBefore(dataB)) {
    return -1;
  }
  return 0;
};

const normalitzarTextSenseAccentsNiMajuscules = text =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
